import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertWaterLevel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M46.675 47.5C41.8 47.5 41.45 50 38.35 50C35.375 50 34.8 47.5 30.025 47.5C25.15 47.5 24.775 50 21.675 50C18.575 50 18.225 47.5 13.35 47.5C8.475 47.5 8.1 50 5 50V55C9.875 55 10.275 52.5 13.35 52.5C16.45 52.5 16.8 55 21.675 55C26.55 55 26.925 52.5 30.025 52.5C33.075 52.5 33.525 55 38.35 55C43.175 55 43.6 52.5 46.675 52.5C49.725 52.5 50.175 55 55 55V50C51.9 50 51.55 47.5 46.675 47.5Z",
		fill: "#FBC02D"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.7 43.75C26.575 43.75 26.925 41.25 30.025 41.25C33 41.25 33.575 43.75 38.35 43.75C43.225 43.75 43.575 41.25 46.675 41.25C49.65 41.25 50.175 43.7 54.95 43.75V38.75C53.375 38.75 52.45 38.05 51.25 37.375L46.2 18.55L51.425 20.675L53.275 16.025L24.45 5L5 29.025L8.925 32.1L12.4 27.65L14.725 36.35C14.275 36.3 13.85 36.225 13.325 36.225C8.45 36.225 8.1 38.725 5 38.725V43.725C9.75 43.725 10.425 41.225 13.375 41.225C16.35 41.25 16.925 43.75 21.7 43.75ZM26.05 11.025L40.4 16.25L45.775 36.3C41.925 36.575 41.225 38.525 38.65 38.7L35.1 25.425L25.45 28.025L27.725 36.5C24.925 37.125 24.2 38.75 21.675 38.75C21.225 38.75 20.85 38.7 20.55 38.625L16.25 22.725L26.05 11.025Z",
		fill: "#FBC02D"
	})]
});
export default SvgAlertWaterLevel;
